import { Bike, Boxes, Motorbike, Scooter, Trees, Zap, type LucideIcon } from 'lucide-react';

/**
 * Retourne l'icône (picto) correspondant au type de produit d'un contrat
 * à partir de son codeProduit.
 */
const getProductIcon = (codeProduit?: string): LucideIcon => {
    if (!codeProduit) return Motorbike;
    const code = codeProduit.toUpperCase();
    if (code.includes('VAE') || code.includes('VELO')) return Bike;
    if (code.includes('MAE') && code.includes('NVEI')) return Zap;
    if (code.includes('NVEI') || code.includes('TROT')) return Scooter;
    if (code.includes('QUAD') || code.includes('VERTE') || code.includes('QUA') || code.includes('MVE')) return Trees;
    if (code.includes('LIV') || code.includes('LIVRAISON')) return Boxes;
    return Motorbike;
};

// Liste des pictos de produits affichés dans le header.
export const ALL_PRODUCT_ICONS = [Motorbike, Bike, Scooter];

export default getProductIcon;
